//This is a copy from the client folder and this needs to be updated.
//service/src/utils/countryOptions.js

export const canadianProvinces = [
  { code: "AB", label: "(CA) AB - Alberta" },
  { code: "BC", label: "(CA) BC - British Columbia" },
  { code: "MB", label: "(CA) MB - Manitoba" },
  { code: "NB", label: "(CA) NB - New Brunswick" },
  { code: "NF", label: "(CA) NF - Newfoundland and Labrador" },
  { code: "NS", label: "(CA) NS - Nova Scotia" },
  { code: "NT", label: "(CA) NT - Northwest Territories" },
  { code: "NU", label: "(CA) NU - Nunavut" },
  { code: "ON", label: "(CA) ON - Ontario" },
  { code: "PE", label: "(CA) PE - Prince Edward Island" },
  { code: "QC", label: "(CA) QC - Quebec" },
  { code: "SK", label: "(CA) SK - Saskatchewan" },
  { code: "YT", label: "(CA) YT - Yukon" },
  { code: "CA", label: "(CA)" }

];

export const usStates =  [
        { key : "AK", label : "Alaska" },
        { key : "AL", label : "Alabama"},
        { key : "AR", label : "Arkansas" },
        { key : "AZ", label : "Arizona" },
        { key : "CA", label : "California" },
        { key : "CO", label : "Colorado" },
        { key : "CT", label : "Connecticut" },
        { key : "DC", label : "District of Columbia" },
        { key : "DE", label : "Delaware" },
        { key : "FL", label : "Florida" }, 
        { key : "GA", label : "Georgia" },
        { key : "HI", label : "Hawaii" }, 
        { key : "IA", label : "Iowa" }, 
        { key : "ID", label : "Idaho" },
        { key : "IL", label : "Illinois" },
        { key : "IN", label : "Indiana" },
        { key : "KS", label : "Kansas" },
        { key : "KY", label : "Kentucky" },
        { key : "LA", label : "Louisiana" },
        { key : "MA", label : "Massachusetts" },
        { key : "MD", label : "Maryland" }, 
        { key : "ME", label : "Maine" },
        { key : "MI", label : "Michigan" }, 
        { key : "MN", label : "Minnesota" },
        { key : "MO", label : "Missouri" },
        { key : "MS", label : "Mississippi" },
        { key : "MT", label : "Montana" },
        { key : "NC", label : "North Carolina" },
        { key : "ND", label : "North Dakota" },
        { key : "NE", label : "Nebraska" },
        { key : "NH", label : "New Hampshire" },
        { key : "NJ", label : "New Jersey" },
        { key : "NM", label : "New Mexico" },
        { key : "NV", label : "Nevada" },
        { key : "NY", label : "New York" },
        { key : "OH", label : "Ohio" },
        { key : "OK", label : "Oklahoma" },
        { key : "OR", label : "Oregon" },
        { key : "PA", label : "Pennsylvania" },
        { key : "RI", label : "Rhode Island" },
        { key : "SC", label : "South Carolina" },
        { key : "SD", label : "South Dakota" },
        { key : "TN", label : "Tennessee" },
        { key : "TX", label : "Texas" },
        { key : "UT", label : "Utah" },
        { key : "VA", label : "Virginia" },
        { key : "VT", label : "Vermont" },
        { key : "WA", label : "Washington" },
        { key : "WI", label : "Wisconsin" },
        { key : "WV", label : "West Virginia" },
        { key : "WY", label : "Wyoming" }
    ]

export const mexicanStates = [
  {code: "MX", label: "(MX) MX - Mexico"},
  {code: "AG", label: "(MX) AG - Aguascalientes"},
  {code: "BA", label: "(MX) BA - Baja California"},  
  {code: "BJ", label: "(MX) BJ - Baja California Sur"},  
  {code: "CE", label: "(MX) CE - Campeche"},  
  {code: "CI", label: "(MX) CI - Chiapas"},  
  {code: "CH", label: "(MX) CH - Chihuahua"},  
  {code: "CU", label: "(MX) CU - Coahuila de Zaragoza"},  
  {code: "CL", label: "(MX) CL - Colima"}, 
  {code: "DF", label: "(MX) DF - Distrito Federal Mexico"},
  {code: "DO", label: "(MX) DO - Durango"}, 
  {code: "EM", label: "(MX) EM - Estado de Mexico"},  
  {code: "GR", label: "(MX) GR - Guerrero"},   
  {code: "GU", label: "(MX) GU - Guanajuato"}, 
  {code: "HL", label: "(MX) HL - Hidalgo"},  
  {code: "JL", label: "(MX) JL - Jalisco"},   
  {code: "MC", label: "(MX) MC - Michoacan de Ocampo"},  
  {code: "MR", label: "(MX) MR - Morelos"},  
  {code: "NA", label: "(MX) NA - Nayarit"},  
  {code: "NL", label: "(MX) NL - Nuevo Leon"},  
  {code: "OA", label: "(MX) OA - Oaxaca"},  
  {code: "PB", label: "(MX) PB - Puebla"},  
  {code: "QU", label: "(MX) QU - Queretaro de Arteaga"},  
  {code: "QR", label: "(MX) QR - Quintana Roo"},  
  {code: "SL", label: "(MX) SL - San Luis Potosi"},  
  {code: "SI", label: "(MX) SI - Sinaloa"},
  {code: "SO", label: "(MX) SO - Sonora"},  
  {code: "TB", label: "(MX) TB - Tabasco"},  
  {code: "TA", label: "(MX) TA - Tamaulipas"},  
  {code: "TL", label: "(MX) TL - Tlaxcala"},  
  {code: "VC", label: "(MX) VC - Veracruz-Llave"},  
  {code: "YU", label: "(MX) YU - Yucatan"}, 
  {code: "ZA", label: "(MX) ZA - Zacatecas"}
];

export const countryOptions = {
  "CA":[
    {
      code: "CA",
      label: "(CA) CA - Canada",
      "spanish": false
    }
  ],
  "MX": [
    {
      code: "MX",
      label: "(MX) MX - Mexico",
      "spanish": true
    }
  ],
  "US": [
    {
      code: "AS",
      label: "(US) AS - American Samoa",
      "spanish": false
    },
    {
      code: "FM",
      label: "(US) FM - Federated States of Micronesia",
      "spanish": false
    },
    {
      code: "GM",
      label: "(US) GM - Guam",
      "spanish": false
    },
    {
      code: "MH",
      label: "(US) MH - Marshall Islands",
      "spanish": false
    },
    {
      code: "MP",
      label: "(US) MP - Northern Mariana Islands",
      "spanish": false
    },
    {
      code: "PR",
      label: "(US) PR - Puerto Rico",
      "spanish": true
    },
    {
      code: "PW",
      label: "(US) PW - Palau",
      "spanish": false
    },
    {
      code: "PZ",
      label: "(US) PZ - Panamanian Canal Zone",
      "spanish": true
    },
    // {
    //   code: "UMI",
    //   label: "(US) UMI - Minor Outlying Islands"
    // },
    {
      code: "VI",
      label: "(US) VI - Virgin Islands",
      "spanish": false
    },
    {
      code: "WK",
      label: "(US) WK - Wake Island",
      "spanish": false
    }
  ],
  "OTH": [
    {
      code: "ABW",
      label: "(OTH) ABW - Aruba",
      "spanish": false
    },
    {
      code: "AFG",
      label: "(OTH) AFG - Afghanistan",
      "spanish": false
    },
    {
      code: "AGO",
      label: "(OTH) AGO - Angola",
      "spanish": false
    },
    {
      code: "AIA",
      label: "(OTH) AIA - Anguilla",
      "spanish": false
    },
    {
      code: "ALA",
      label: "(OTH) ALA - \u00c5land Islands",
      "spanish": false
    },
    {
      code: "ALB",
      label: "(OTH) ALB - Albania",
      "spanish": false
    },
    {
      code: "AND",
      label: "(OTH) AND - Andorra",
      "spanish": false
    },
    {
      code: "ARE",
      label: "(OTH) ARE - United Arab Emirates",
      "spanish": false
    },
    {
      code: "ARG",
      label: "(OTH) ARG - Argentina",
      "spanish": true
    },
    {
      code: "ARM",
      label: "(OTH) ARM - Armenia",
      "spanish": false
    },
    {
      code: "ATA",
      label: "(OTH) ATA - Antarctica",
      "spanish": false
    },
    {
      code: "ATF",
      label: "(OTH) ATF - French Southern Territories",
      "spanish": false
    },
    {
      code: "ATG",
      label: "(OTH) ATG - Antigua and Barbuda",
      "spanish": false
    },
    {
      code: "AUS",
      label: "(OTH) AUS - Australia",
      "spanish": false
    },
    {
      code: "AUT",
      label: "(OTH) AUT - Austria",
      "spanish": false
    },
    {
      code: "AZE",
      label: "(OTH) AZE - Azerbaijan",
      "spanish": false
    },
    {
      code: "BDI",
      label: "(OTH) BDI - Burundi",
      "spanish": false
    },
    {
      code: "BEL",
      label: "(OTH) BEL - Belgium",
      "spanish": false
    },
    {
      code: "BEN",
      label: "(OTH) BEN - Benin",
      "spanish": false
    },
    {
      code: "BES",
      label: "(OTH) BES - Bonaire, Sint Eustatius and Saba",
      "spanish": false
    },
    {
      code: "BFA",
      label: "(OTH) BFA - Burkina Faso",
      "spanish": false
    },
    {
      code: "BGD",
      label: "(OTH) BGD - Bangladesh",
      "spanish": false
    },
    {
      code: "BGR",
      label: "(OTH) BGR - Bulgaria",
      "spanish": false
    },
    {
      code: "BHR",
      label: "(OTH) BHR - Bahrain",
      "spanish": false
    },
    {
      code: "BHS",
      label: "(OTH) BHS - Bahamas",
      "spanish": false
    },
    {
      code: "BIH",
      label: "(OTH) BIH - Bosnia and Herzegovina",
      "spanish": false
    },
    {
      code: "BLM",
      label: "(OTH) BLM - Saint Barth\u00e9lemy",
      "spanish": false
    },
    {
      code: "BLR",
      label: "(OTH) BLR - Belarus",
      "spanish": false
    },
    {
      code: "BLZ",
      label: "(OTH) BLZ - Belize",
      "spanish": false
    },
    {
      code: "BMU",
      label: "(OTH) BMU - Bermuda",
      "spanish": false
    },
    {
      code: "BOL",
      label: "(OTH) BOL - Bolivia, Plurinational State of",
      "spanish": true
    },
    {
      code: "BRA",
      label: "(OTH) BRA - Brazil",
      "spanish": false
    },
    {
      code: "BRB",
      label: "(OTH) BRB - Barbados",
      "spanish": false
    },
    {
      code: "BRN",
      label: "(OTH) BRN - Brunei Darussalam",
      "spanish": false
    },
    {
      code: "BTN",
      label: "(OTH) BTN - Bhutan",
      "spanish": false
    },
    {
      code: "BVT",
      label: "(OTH) BVT - Bouvet Island",
      "spanish": false
    },
    {
      code: "BWA",
      label: "(OTH) BWA - Botswana",
      "spanish": false
    },
    {
      code: "CAF",
      label: "(OTH) CAF - Central African Republic",
      "spanish": false
    },
    {
      code: "CAN",
      label: "(OTH) CAN - Canada",
      "spanish": false
    },
    {
      code: "CCK",
      label: "(OTH) CCK - Cocos (Keeling) Islands",
      "spanish": false
    },
    {
      code: "CHE",
      label: "(OTH) CHE - Switzerland",
      "spanish": false
    },
    {
      code: "CHL",
      label: "(OTH) CHL - Chile",
      "spanish": true
    },
    {
      code: "CHN",
      label: "(OTH) CHN - China",
      "spanish": false
    },
    {
      code: "CIV",
      label: "(OTH) CIV - C\u00f4te d\'Ivoire",
      "spanish": false
    },
    {
      code: "CMR",
      label: "(OTH) CMR - Cameroon",
      "spanish": false
    },
    {
      code: "COD",
      label: "(OTH) COD - Congo, The Democratic Republic of the",
      "spanish": false
    },
    {
      code: "COG",
      label: "(OTH) COG - Congo",
      "spanish": false
    },
    {
      code: "COK",
      label: "(OTH) COK - Cook Islands",
      "spanish": false
    },
    {
      code: "COL",
      label: "(OTH) COL - Colombia",
      "spanish": true
    },
    {
      code: "COM",
      label: "(OTH) COM - Comoros",
      "spanish": false
    },
    {
      code: "CPV",
      label: "(OTH) CPV - Cabo Verde",
      "spanish": false
    },
    {
      code: "CRI",
      label: "(OTH) CRI - Costa Rica",
      "spanish": true
    },
    {
      code: "CUB",
      label: "(OTH) CUB - Cuba",
      "spanish": true
    },
    {
      code: "CUW",
      label: "(OTH) CUW - Cura\u00e7ao",
      "spanish": false
    },
    {
      code: "CXR",
      label: "(OTH) CXR - Christmas Island",
      "spanish": false
    },
    {
      code: "CYM",
      label: "(OTH) CYM - Cayman Islands",
      "spanish": false
    },
    {
      code: "CYP",
      label: "(OTH) CYP - Cyprus",
      "spanish": false
    },
    {
      code: "CZE",
      label: "(OTH) CZE - Czechia",
      "spanish": false
    },
    {
      code: "DEU",
      label: "(OTH) DEU - Germany",
      "spanish": false
    },
    {
      code: "DJI",
      label: "(OTH) DJI - Djibouti",
      "spanish": false
    },
    {
      code: "DMA",
      label: "(OTH) DMA - Dominica",
      "spanish": false
    },
    {
      code: "DNK",
      label: "(OTH) DNK - Denmark",
      "spanish": false
    },
    {
      code: "DOM",
      label: "(OTH) DOM - Dominican Republic",
      "spanish": true
    },
    {
      code: "DZA",
      label: "(OTH) DZA - Algeria",
      "spanish": false
    },
    {
      code: "ECU",
      label: "(OTH) ECU - Ecuador",
      "spanish": true
    },
    {
      code: "EGY",
      label: "(OTH) EGY - Egypt",
      "spanish": false
    },
    {
      code: "ERI",
      label: "(OTH) ERI - Eritrea",
      "spanish": false
    },
    {
      code: "ESH",
      label: "(OTH) ESH - Western Sahara",
      "spanish": false
    },
    {
      code: "ESP",
      label: "(OTH) ESP - Spain",
      "spanish": true
    },
    {
      code: "EST",
      label: "(OTH) EST - Estonia",
      "spanish": false
    },
    {
      code: "ETH",
      label: "(OTH) ETH - Ethiopia",
      "spanish": false
    },
    {
      code: "FIN",
      label: "(OTH) FIN - Finland",
      "spanish": false
    },
    {
      code: "FJI",
      label: "(OTH) FJI - Fiji",
      "spanish": false
    },
    {
      code: "FLK",
      label: "(OTH) FLK - Falkland Islands (Malvinas)",
      "spanish": false
    },
    {
      code: "FRA",
      label: "(OTH) FRA - France",
      "spanish": false
    },
    {
      code: "FRO",
      label: "(OTH) FRO - Faroe Islands",
      "spanish": false
    },
    {
      code: "FSM",
      label: "(OTH) FSM - Micronesia, Federated States of",
      "spanish": false
    },
    {
      code: "GAB",
      label: "(OTH) GAB - Gabon",
      "spanish": false
    },
    {
      code: "GBR",
      label: "(OTH) GBR - United Kingdom",
      "spanish": false
    },
    {
      code: "GEO",
      label: "(OTH) GEO - Georgia",
      "spanish": false
    },
    {
      code: "GGY",
      label: "(OTH) GGY - Guernsey",
      "spanish": false
    },
    {
      code: "GHA",
      label: "(OTH) GHA - Ghana",
      "spanish": false
    },
    {
      code: "GIB",
      label: "(OTH) GIB - Gibraltar",
      "spanish": false
    },
    {
      code: "GIN",
      label: "(OTH) GIN - Guinea",
      "spanish": false
    },
    {
      code: "GLP",
      label: "(OTH) GLP - Guadeloupe",
      "spanish": false
    },
    {
      code: "GMB",
      label: "(OTH) GMB - Gambia",
      "spanish": false
    },
    {
      code: "GNB",
      label: "(OTH) GNB - Guinea-Bissau",
      "spanish": false
    },
    {
      code: "GNQ",
      label: "(OTH) GNQ - Equatorial Guinea",
      "spanish": true
    },
    {
      code: "GRC",
      label: "(OTH) GRC - Greece",
      "spanish": false
    },
    {
      code: "GRD",
      label: "(OTH) GRD - Grenada",
      "spanish": false
    },
    {
      code: "GRL",
      label: "(OTH) GRL - Greenland",
      "spanish": false
    },
    {
      code: "GTM",
      label: "(OTH) GTM - Guatemala",
      "spanish": true
    },
    {
      code: "GUF",
      label: "(OTH) GUF - French Guiana",
      "spanish": false
    },
    {
      code: "GUY",
      label: "(OTH) GUY - Guyana",
      "spanish": false
    },
    {
      code: "HKG",
      label: "(OTH) HKG - Hong Kong",
      "spanish": false
    },
    {
      code: "HMD",
      label: "(OTH) HMD - Heard Island and McDonald Islands",
      "spanish": false
    },
    {
      code: "HND",
      label: "(OTH) HND - Honduras",
      "spanish": true
    },
    {
      code: "HRV",
      label: "(OTH) HRV - Croatia",
      "spanish": false
    },
    {
      code: "HTI",
      label: "(OTH) HTI - Haiti",
      "spanish": false
    },
    {
      code: "HUN",
      label: "(OTH) HUN - Hungary",
      "spanish": false
    },
    {
      code: "IDN",
      label: "(OTH) IDN - Indonesia",
      "spanish": false
    },
    {
      code: "IMN",
      label: "(OTH) IMN - Isle of Man",
      "spanish": false
    },
    {
      code: "IND",
      label: "(OTH) IND - India",
      "spanish": false
    },
    {
      code: "IOT",
      label: "(OTH) IOT - British Indian Ocean Territory",
      "spanish": false
    },
    {
      code: "IRL",
      label: "(OTH) IRL - Ireland",
      "spanish": false
    },
    {
      code: "IRN",
      label: "(OTH) IRN - Iran, Islamic Republic of",
      "spanish": false
    },
    {
      code: "IRQ",
      label: "(OTH) IRQ - Iraq",
      "spanish": false
    },
    {
      code: "ISL",
      label: "(OTH) ISL - Iceland",
      "spanish": false
    },
    {
      code: "ISR",
      label: "(OTH) ISR - Israel",
      "spanish": false
    },
    {
      code: "ITA",
      label: "(OTH) ITA - Italy",
      "spanish": false
    },
    {
      code: "JAM",
      label: "(OTH) JAM - Jamaica",
      "spanish": false
    },
    {
      code: "JEY",
      label: "(OTH) JEY - Jersey",
      "spanish": false
    },
    {
      code: "JOR",
      label: "(OTH) JOR - Jordan",
      "spanish": false
    },
    {
      code: "JPN",
      label: "(OTH) JPN - Japan",
      "spanish": false
    },
    {
      code: "KAZ",
      label: "(OTH) KAZ - Kazakhstan",
      "spanish": false
    },
    {
      code: "KEN",
      label: "(OTH) KEN - Kenya",
      "spanish": false
    },
    {
      code: "KGZ",
      label: "(OTH) KGZ - Kyrgyzstan",
      "spanish": false
    },
    {
      code: "KHM",
      label: "(OTH) KHM - Cambodia",
      "spanish": false
    },
    {
      code: "KIR",
      label: "(OTH) KIR - Kiribati",
      "spanish": false
    },
    {
      code: "KNA",
      label: "(OTH) KNA - Saint Kitts and Nevis",
      "spanish": false
    },
    {
      code: "KOR",
      label: "(OTH) KOR - Korea, Republic of",
      "spanish": false
    },
    {
      code: "KWT",
      label: "(OTH) KWT - Kuwait",
      "spanish": false
    },
    {
      code: "LAO",
      label: "(OTH) LAO - Lao People's Democratic Republic",
      "spanish": false
    },
    {
      code: "LBN",
      label: "(OTH) LBN - Lebanon",
      "spanish": false
    },
    {
      code: "LBR",
      label: "(OTH) LBR - Liberia",
      "spanish": false
    },
    {
      code: "LBY",
      label: "(OTH) LBY - Libya",
      "spanish": false
    },
    {
      code: "LCA",
      label: "(OTH) LCA - Saint Lucia",
      "spanish": false
    },
    {
      code: "LIE",
      label: "(OTH) LIE - Liechtenstein",
      "spanish": false
    },
    {
      code: "LKA",
      label: "(OTH) LKA - Sri Lanka",
      "spanish": false
    },
    {
      code: "LSO",
      label: "(OTH) LSO - Lesotho",
      "spanish": false
    },
    {
      code: "LTU",
      label: "(OTH) LTU - Lithuania",
      "spanish": false
    },
    {
      code: "LUX",
      label: "(OTH) LUX - Luxembourg",
      "spanish": false
    },
    {
      code: "LVA",
      label: "(OTH) LVA - Latvia",
      "spanish": false
    },
    {
      code: "MAC",
      label: "(OTH) MAC - Macao",
      "spanish": false
    },
    {
      code: "MAF",
      label: "(OTH) MAF - Saint Martin (French part)",
      "spanish": false
    },
    {
      code: "MAR",
      label: "(OTH) MAR - Morocco",
      "spanish": false
    },
    {
      code: "MCO",
      label: "(OTH) MCO - Monaco",
      "spanish": false
    },
    {
      code: "MDA",
      label: "(OTH) MDA - Moldova, Republic of",
      "spanish": false
    },
    {
      code: "MDG",
      label: "(OTH) MDG - Madagascar",
      "spanish": false
    },
    {
      code: "MDV",
      label: "(OTH) MDV - Maldives",
      "spanish": false
    },
    {
      code: "MHL",
      label: "(OTH) MHL - Marshall Islands",
      "spanish": false
    },
    {
      code: "MKD",
      label: "(OTH) MKD - North Macedonia",
      "spanish": false
    },
    {
      code: "MLI",
      label: "(OTH) MLI - Mali",
      "spanish": false
    },
    {
      code: "MLT",
      label: "(OTH) MLT - Malta",
      "spanish": false
    },
    {
      code: "MMR",
      label: "(OTH) MMR - Myanmar",
      "spanish": false
    },
    {
      code: "MNE",
      label: "(OTH) MNE - Montenegro",
      "spanish": false
    },
    {
      code: "MNG",
      label: "(OTH) MNG - Mongolia",
      "spanish": false
    },
    {
      code: "MOZ",
      label: "(OTH) MOZ - Mozambique",
      "spanish": false
    },
    {
      code: "MRT",
      label: "(OTH) MRT - Mauritania",
      "spanish": false
    },
    {
      code: "MSR",
      label: "(OTH) MSR - Montserrat",
      "spanish": false
    },
    {
      code: "MTQ",
      label: "(OTH) MTQ - Martinique",
      "spanish": false
    },
    {
      code: "MUS",
      label: "(OTH) MUS - Mauritius",
      "spanish": false
    },
    {
      code: "MWI",
      label: "(OTH) MWI - Malawi",
      "spanish": false
    },
    {
      code: "MYS",
      label: "(OTH) MYS - Malaysia",
      "spanish": false
    },
    {
      code: "MYT",
      label: "(OTH) MYT - Mayotte",
      "spanish": false
    },
    {
      code: "NAM",
      label: "(OTH) NAM - Namibia",
      "spanish": false
    },
    {
      code: "NCL",
      label: "(OTH) NCL - New Caledonia",
      "spanish": false
    },
    {
      code: "NER",
      label: "(OTH) NER - Niger",
      "spanish": false
    },
    {
      code: "NFK",
      label: "(OTH) NFK - Norfolk Island",
      "spanish": false
    },
    {
      code: "NGA",
      label: "(OTH) NGA - Nigeria",
      "spanish": false
    },
    {
      code: "NIC",
      label: "(OTH) NIC - Nicaragua",
      "spanish": true
    },
    {
      code: "NIU",
      label: "(OTH) NIU - Niue",
      "spanish": false
    },
    {
      code: "NLD",
      label: "(OTH) NLD - Netherlands",
      "spanish": false
    },
    {
      code: "NOR",
      label: "(OTH) NOR - Norway",
      "spanish": false
    },
    {
      code: "NPL",
      label: "(OTH) NPL - Nepal",
      "spanish": false
    },
    {
      code: "NRU",
      label: "(OTH) NRU - Nauru",
      "spanish": false
    },
    {
      code: "NZL",
      label: "(OTH) NZL - New Zealand",
      "spanish": false
    },
    {
      code: "OMN",
      label: "(OTH) OMN - Oman",
      "spanish": false
    },
    {
      code: "PAK",
      label: "(OTH) PAK - Pakistan",
      "spanish": false
    },
    {
      code: "PAN",
      label: "(OTH) PAN - Panama",
      "spanish": true
    },
    {
      code: "PCN",
      label: "(OTH) PCN - Pitcairn",
      "spanish": false
    },
    {
      code: "PER",
      label: "(OTH) PER - Peru",
      "spanish": true
    },
    {
      code: "PHL",
      label: "(OTH) PHL - Philippines",
      "spanish": false
    },
    {
      code: "PLW",
      label: "(OTH) PLW - Palau",
      "spanish": false
    },
    {
      code: "PNG",
      label: "(OTH) PNG - Papua New Guinea",
      "spanish": false
    },
    {
      code: "POL",
      label: "(OTH) POL - Poland",
      "spanish": false
    },
    {
      code: "PRK",
      label: "(OTH) PRK - Korea, Democratic People\'s Republic of",
      "spanish": false
    },
    {
      code: "PRT",
      label: "(OTH) PRT - Portugal",
      "spanish": false
    },
    {
      code: "PRY",
      label: "(OTH) PRY - Paraguay",
      "spanish": true
    },
    {
      code: "PSE",
      label: "(OTH) PSE - Palestine, State of",
      "spanish": false
    },
    {
      code: "PYF",
      label: "(OTH) PYF - French Polynesia",
      "spanish": false
    },
    {
      code: "QAT",
      label: "(OTH) QAT - Qatar",
      "spanish": false
    },
    {
      code: "REU",
      label: "(OTH) REU - R\u00e9union",
      "spanish": false
    },
    {
      code: "ROU",
      label: "(OTH) ROU - Romania",
      "spanish": false
    },
    {
      code: "RUS",
      label: "(OTH) RUS - Russian Federation",
      "spanish": false
    },
    {
      code: "RWA",
      label: "(OTH) RWA - Rwanda",
      "spanish": false
    },
    {
      code: "SAU",
      label: "(OTH) SAU - Saudi Arabia",
      "spanish": false
    },
    {
      code: "SDN",
      label: "(OTH) SDN - Sudan",
      "spanish": false
    },
    {
      code: "SEN",
      label: "(OTH) SEN - Senegal",
      "spanish": false
    },
    {
      code: "SGP",
      label: "(OTH) SGP - Singapore",
      "spanish": false
    },
    {
      code: "SGS",
      label: "(OTH) SGS - South Georgia and the South Sandwich Islands",
      "spanish": false
    },
    {
      code: "SHN",
      label: "(OTH) SHN - Saint Helena, Ascension and Tristan da Cunha",
      "spanish": false
    },
    {
      code: "SJM",
      label: "(OTH) SJM - Svalbard and Jan Mayen",
      "spanish": false
    },
    {
      code: "SLB",
      label: "(OTH) SLB - Solomon Islands",
      "spanish": false
    },
    {
      code: "SLE",
      label: "(OTH) SLE - Sierra Leone",
      "spanish": false
    },
    {
      code: "SLV",
      label: "(OTH) SLV - El Salvador",
      "spanish": true
    },
    {
      code: "SMR",
      label: "(OTH) SMR - San Marino",
      "spanish": false
    },
    {
      code: "SOM",
      label: "(OTH) SOM - Somalia",
      "spanish": false
    },
    {
      code: "SPM",
      label: "(OTH) SPM - Saint Pierre and Miquelon",
      "spanish": false
    },
    {
      code: "SRB",
      label: "(OTH) SRB - Serbia",
      "spanish": false
    },
    {
      code: "SSD",
      label: "(OTH) SSD - South Sudan",
      "spanish": false
    },
    {
      code: "STP",
      label: "(OTH) STP - Sao Tome and Principe",
      "spanish": false
    },
    {
      code: "SUR",
      label: "(OTH) SUR - Suriname",
      "spanish": false
    },
    {
      code: "SVK",
      label: "(OTH) SVK - Slovakia",
      "spanish": false
    },
    {
      code: "SVN",
      label: "(OTH) SVN - Slovenia",
      "spanish": false
    },
    {
      code: "SWE",
      label: "(OTH) SWE - Sweden",
      "spanish": false
    },
    {
      code: "SWZ",
      label: "(OTH) SWZ - Eswatini",
      "spanish": false
    },
    {
      code: "SXM",
      label: "(OTH) SXM - Sint Maarten (Dutch part)",
      "spanish": false
    },
    {
      code: "SYC",
      label: "(OTH) SYC - Seychelles",
      "spanish": false
    },
    {
      code: "SYR",
      label: "(OTH) SYR - Syrian Arab Republic",
      "spanish": false
    },
    {
      code: "TCA",
      label: "(OTH) TCA - Turks and Caicos Islands",
      "spanish": false
    },
    {
      code: "TCD",
      label: "(OTH) TCD - Chad",
      "spanish": false
    },
    {
      code: "TGO",
      label: "(OTH) TGO - Togo",
      "spanish": false
    },
    {
      code: "THA",
      label: "(OTH) THA - Thailand",
      "spanish": false
    },
    {
      code: "TJK",
      label: "(OTH) TJK - Tajikistan",
      "spanish": false
    },
    {
      code: "TKL",
      label: "(OTH) TKL - Tokelau",
      "spanish": false
    },
    {
      code: "TKM",
      label: "(OTH) TKM - Turkmenistan",
      "spanish": false
    },
    {
      code: "TLS",
      label: "(OTH) TLS - Timor-Leste",
      "spanish": false
    },
    {
      code: "TON",
      label: "(OTH) TON - Tonga",
      "spanish": false
    },
    {
      code: "TTO",
      label: "(OTH) TTO - Trinidad and Tobago",
      "spanish": false
    },
    {
      code: "TUN",
      label: "(OTH) TUN - Tunisia",
      "spanish": false
    },
    {
      code: "TUR",
      label: "(OTH) TUR - Turkey",
      "spanish": false
    },
    {
      code: "TUV",
      label: "(OTH) TUV - Tuvalu",
      "spanish": false
    },
    {
      code: "TWN",
      label: "(OTH) TWN - Taiwan, Province of China",
      "spanish": false
    },
    {
      code: "TZA",
      label: "(OTH) TZA - Tanzania, United Republic of",
      "spanish": false
    },
    {
      code: "UGA",
      label: "(OTH) UGA - Uganda",
      "spanish": false
    },
    {
      code: "UKR",
      label: "(OTH) UKR - Ukraine",
      "spanish": false
    },
    {
      code: "UMI",
      label: "(OTH) UMI - United States Minor Outlying Islands",
      "spanish": false
    },
    {
      code: "URY",
      label: "(OTH) URY - Uruguay",
      "spanish": false
    },
    {
      code: "USA",
      label: "(OTH) USA - United States",
      "spanish": false
    },
    {
      code: "UZB",
      label: "(OTH) UZB - Uzbekistan",
      "spanish": false
    },
    {
      code: "VAT",
      label: "(OTH) VAT - Holy See (Vatican City State)",
      "spanish": false
    },
    {
      code: "VCT",
      label: "(OTH) VCT - Saint Vincent and the Grenadines",
      "spanish": false
    },
    {
      code: "VEN",
      label: "(OTH) VEN - Venezuela, Bolivarian Republic of",
      "spanish": true
    },
    {
      code: "VGB",
      label: "(OTH) VGB - Virgin Islands, British",
      "spanish": false
    },
    {
      code: "VNM",
      label: "(OTH) VNM - Viet Nam",
      "spanish": false
    },
    {
      code: "VUT",
      label: "(OTH) VUT - Vanuatu",
      "spanish": false
    },
    {
      code: "WLF",
      label: "(OTH) WLF - Wallis and Futuna",
      "spanish": false
    },
    {
      code: "WSM",
      label: "(OTH) WSM - Samoa",
      "spanish": false
    },
    {
      code: "YEM",
      label: "(OTH) YEM - Yemen",
      "spanish": false
    },
    {
      code: "ZAF",
      label: "(OTH) ZAF - South Africa",
      "spanish": false
    },
    {
      code: "ZMB",
      label: "(OTH) ZMB - Zambia",
      "spanish": false
    },
    {
      code: "ZWE",
      label: "(OTH) ZWE - Zimbabwe",
      "spanish": false
    }
  ]
};